/* eslint-disable global-require */
const { en: common } = require("../../common");

module.exports = {
	...common,
	"section-try-for-free": require("../../section-try-for-free/en/section-try-for-free.json"),
	guides: require("./guides.json"),
};
